<icc-select-box
    *ngIf="(cylinderMainLock$ | async)"
    [title]="'DOOR|Rodzaj wkładki zamka głównego' | translate"
    [description]="(cylinderMainLock$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((cylinderMainLock$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="((isKeyAvailableForMainLock) && 'INTERFACE|Opcje' | translate)"
    (select)="changeCylinderToMainLock()"
    (select2)="changeCylinderToMainLockOptions()"
    [disabledButton1]="isCylinderMainLockButtonDisabled()"
></icc-select-box>
<icc-select-box
    *ngIf="(cylinderAdditionalLock$ | async)"
    [title]="'DOOR|Rodzaj wkładki zamka dodatkowego' | translate"
    [description]="(cylinderAdditionalLock$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((cylinderAdditionalLock$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="((isKeyAvailableForAdditionalLock) && 'INTERFACE|Opcje' | translate)"
    (select)="changeCylinderToAdditionalLock()"
    (select2)="changeCylinderToAdditionalLockOptions()"
    [disabledButton1]="isCylinderAdditionalLockButtonDisabled()"
></icc-select-box>
<icc-select-box
    *ngIf="(cylinderSystem$ | async)"
    [title]="'DOOR|System wkładek' | translate"
    [description]="(cylinderSystem$ | async)?.name"
    [imageUrl]="'/files/windowaccessorysystem/' + ((cylinderSystem$ | async)?.image || '')"
    [disabledButton1]="isCylinderSystemButtonDisabled()"
></icc-select-box>
<icc-select-box
    [title]="'DOOR|Typ elektronicznej wkładki' | translate"
    [description]="(electronicLock$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((electronicLock$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeElectronicLock()"
    *ngIf = "(cylinderMainLock$ | async)?.electronic_door_lock"
    [disabledButton1]="isElectronickLockButtonDisabled()"
></icc-select-box>
